<template>
    <div class="videoroom-wrapper">
        <div class="videoroom" :ref="'videoroom'" :class="{'explayout': experimentalLayout}">
            <div class="videoroom-inner clear">
                <div class="content">
                    <!--<div class="content-header">-->
                    <!--<h2>{{room.roomName}}</h2>-->
                    <!--</div>-->
                    <div class="content-video">
                        <div class="spacer"></div>
                        <!--<video id="video" :ref="'video'" autoplay playsinline>-->
                            <!--<source src="https://neuclnlds50lon.akamaized.net/nlds/eleven2/eleven_pl_pl/as/live/eleven_pl_pl_hd_pc.m3u8?hdnea=exp=1527368667~acl=/nlds/eleven2/eleven_pl_pl/as/*~hmac=6F51BC816372DA7F39494A23297D4977A63FC70053518496AE3BDC96B4F89CD6" type="application/x-mpegURL">-->
                            <!--Your browser does not support the video tag.-->
                        <!--</video>-->
                        <div v-if="room.roomId != 20161">
                            <video id="video" :ref="'video'" autoplay playsinline></video>
                            <div class="content-video-controls">
                                <button v-on:click="playPauseVideo" :class="{'fa-pause' : isPlaying && !isPreloading, 'fa-play' : !isPlaying && !isPreloading, 'fa-spinner fa-spin': isPreloading }" class="fas align-left"></button>
                                <div class="content-video-controls-volume-control align-left">
                                    <div class="clear">
                                        <button v-on:click="toggleMute" :class="[isMuted ? 'fa-volume-off' : 'fa-volume-up']" class="fas align-left"></button>
                                        <input v-model="volume" @change="setVolume" class="content-video-controls-volume-range align-left" type="range" min="0" max="1" value="0" step="0.01">
                                    </div>
                                </div>
                                <button v-on:click="toggleFullscreen" :class="[isFullscreen ? 'fa-compress' : 'fa-expand']" class="fas align-right"></button>
                                <button v-on:click="toggleLayout" :class="[experimentalLayout ? 'fa-user-circle' : 'fa-user']" class="fas align-right"></button>
                            </div>
                        </div>
                        <iframe v-else class="panel-body" :src="room.streamUrl" frameborder="0"></iframe>
                    </div>
                    <div class="content-info">
                        <!--<div class="content-info-select-channel">-->
                        <!--<span>Select channel</span>-->
                        <!--<img src="../assets/eleven-sports-logo-channel.png"/>-->
                        <!--</div>-->
                        <!--<div class="content-info-description">-->
                        <!--<div class="content-info-description-title">{{room.name}}</div>-->
                        <!--<div class="content-info-description-desc">Kick-off @ 15:00</div>-->
                        <!--</div>-->
                    </div>
                    <!--<div v-if="!experimentalLayout && isFullscreen" class="banner"><img src="../assets/banner.jpg"/></div>-->
                </div>
                <div class="participants">
                    <!--<div class="participants-count">-->
                    <!--<h4 class="text-right"> {{participantsCount}}/{{participantsLimit}} participants</h4>-->
                    <!--</div>-->
                    <!--<div class="room-info">-->
                    <!--<div class="room-info-participants-count">{{participantsCount}}/{{participantsLimit}}</div>-->
                    <!--<div class="room-info-room-name">{{room.roomName}}</div>-->
                    <!--</div>-->
                    <div class="participants-windows grid grid-pad-n grid-pad-l-0">
                        <video-self class="participants-windows-item col-6 col-l-12"></video-self>
                        <video-participant v-for="item in participants" :key="item.id" :uid="item.id" :displayname="item.displayname" :stream="item.stream" :has-video="item.hasVideo" :is-ready="item.isReady" class="participants-windows-item col-6 col-l-12"></video-participant>
                    </div>
                </div>
            </div>
        </div>
        <div class="schedule">
            <div class="circle"></div>
            <div class="schedule-inner">
                <div class="schedule-entries clear">
                    <div class="schedule-entry headr">
                        <h2>Watch Together</h2>
                        <div class="time">Come on in.</div>
                    </div>
                    <div class="schedule-entry">
                        <h3>Now</h3>
                        <div class="time">5pm - 7.40pm</div>
                        <p>{{room.name}}</p>
                    </div>
                    <div class="schedule-entry">
                        <h3>Next</h3>
                        <div class="time">7.40pm - 8.10pm</div>
                        <p>ITV News Weekday</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="other">
            <div class="other-inner">
                <div class="pad-xbg">
                    <h2>Recently on ITV</h2>
                    <div class="pad-n recent">
                        <div class="grid grid-pad-xbg">
                            <div class="col-12 col-m-6 r-item">
                                <img src="../assets/1.jpeg"/>
                                <div>
                                    <h2>The Jeremy Kyle Show</h2>
                                    <div class="time">Today 9:25am</div>
                                    <p>
                                        Jeremy Kyle's confrontational show in which guests thrash out their issues.
                                    </p>
                                </div>
                            </div>
                            <div class="col-12 col-m-6 r-item">
                                <img src="../assets/2.jpeg"/>
                                <div>
                                    <h2>Lorraine</h2>
                                    <div class="time">Today 8:30am</div>
                                    <p>
                                        Lorraine Kelly presents a topical mix of entertainment, discussion and celebrity gossip.
                                    </p>
                                </div>
                            </div>
                            <div class="col-12 col-m-6 r-item">
                                <img src="../assets/3.jpeg"/>
                                <div>
                                    <h2>Good Morning Britain</h2>
                                    <div class="time">Today 6am</div>
                                    <p>
                                        ITV's breakfast show featuring the latest news, sport and weather.
                                    </p>
                                </div>
                            </div>
                            <div class="col-12 col-m-6 r-item">
                                <img src="../assets/4.jpeg"/>
                                <div>
                                    <h2>Great Art</h2>
                                    <div class="time">Yesterday 10.45pm</div>
                                    <p> - Vincent van Gogh's life has long captured the imagination, but who was he really?</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import VideoSelf from "./VideoSelf";
    import VideoParticipant from "./VideoParticipant";
    import Hls from 'hls.js'

    export default {
        components: {
            VideoParticipant,
            VideoSelf},
        name: "DemoRoom",
        props:['id'],
        created: function() {
            console.log('--------');
            console.log(this.room.roomId);
            console.log('--------');

            this.$videoroom.init(parseInt(this.room.roomId));
        },
        mounted: function() {


            let video = this.$refs['video'];

            this.setVolumeVars();
            if(this.room.roomId !== 20192 && this.room.roomId !== 20161) {

                console.log(this.room.streamUrl);

                // video.addEventListener('canplay', () => { video.play() });
                // video.addEventListener('loadeddata', () => { video.play() });

                if(Hls.isSupported()) {
                    let hls = new Hls();
                    hls.loadSource(this.room.streamUrl);
                    hls.attachMedia(video);
                    hls.on(Hls.Events.MANIFEST_PARSED,function() {
                        console.log('Non Native HLS player');
                        video.play();
                    });
                } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                    console.log('Native HLS player');
                    video.src = this.room.streamUrl;
                    video.addEventListener('canplay', this.playPauseVideo);
                }


                //
                // this.$shaka.polyfill.installAll();
                //
                // // Check to see if the browser supports the basic APIs Shaka needs.
                // if (this.$shaka.Player.isBrowserSupported()) {
                //     // Everything looks good!
                //
                //
                //     // Create a Player instance.
                //     let video = this.$refs['video'];
                //     let player = new this.$shaka.Player(video);
                //
                //     // Attach player to the window to make it easy to access in the JS console.
                //     window.player = player;
                //
                //     // Listen for error events.
                //     player.addEventListener('error', (event) => {
                //         console.log(event.detail);
                //     });
                //
                //     console.log(this.room.streamUrl);
                //     // Try to load a manifest.
                //     // This is an asynchronous process.
                //     player.load(this.room.streamUrl).then(function() {
                //         // This runs if the asynchronous load is successful.
                //         console.log('The video has now been loaded!');
                //     }).catch(e => {
                //         console.log('ERRRRR');
                //         console.log(e);
                //     });  // onError is executed if the asynchronous load fails.
                //
                //
                //
                // } else {
                //     // This browser does not have the minimum set of APIs we need.
                //     console.error('Browser not supported!');
                // }


            }




            document.addEventListener("fullscreenchange", this.setFullscreenProperty);
            document.addEventListener("mozfullscreenchange", this.setFullscreenProperty);
            document.addEventListener("webkitfullscreenchange", this.setFullscreenProperty);
            document.addEventListener("msfullscreenchange", this.setFullscreenProperty);
            video.addEventListener('playing', this.handlePlaying);
            video.addEventListener('pause', this.handlePause);
            video.addEventListener('volumechange', this.setVolumeVars);


        },
        beforeDestroy: function() {
            let video = this.$refs['video'];
            document.removeEventListener("fullscreenchange", this.setFullscreenProperty);
            document.removeEventListener("mozfullscreenchange", this.setFullscreenProperty);
            document.removeEventListener("webkitfullscreenchange", this.setFullscreenProperty);
            document.removeEventListener("msfullscreenchange", this.setFullscreenProperty);
            video.removeEventListener('playing', this.handlePlaying);
            video.removeEventListener('pause', this.handlePause);
            video.removeEventListener('volumechange', this.setVolumeVars);
            video.removeEventListener('canplay', this.playPauseVideo);
            this.$videoroom.destroy();
        },
        data () {
            return {
                _hasMainStream: false,
                experimentalLayout: true,
                isPlaying: false,
                isPreloading: false,
                isFullscreen: false,
                isMuted: false,
                volume: 0,
                participantsLimit:4,
                participants: [this.getBlankCell(),this.getBlankCell(),this.getBlankCell()],
                localStream:null,
            }
        },
        computed: {
            participantsCount: function () {
                return this.participants.filter(participant => !participant.isBlankCell).length + 1;
            },
            room: function () {
                return this.$store.getters['user/getRoomById'](this.id) || {};
            }
        },
        methods: {
            setFullscreenProperty: function() {
                this.isFullscreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
            },
            toggleLayout: function() {
                this.experimentalLayout = !this.experimentalLayout;
            },
            toggleFullscreen: function () {
                let playerElement = this.$refs['videoroom'];
                let fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
                if(fullscreenElement) {
                    if(document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if(document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if(document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    }

                }
                else {
                    if(playerElement.requestFullscreen) {
                        playerElement.requestFullscreen();
                    } else if(playerElement.mozRequestFullScreen) {
                        playerElement.mozRequestFullScreen();
                    } else if(playerElement.webkitRequestFullscreen) {
                        playerElement.webkitRequestFullscreen();
                    }
                }
            },
            playPauseVideo: function (event) {
                event.stopPropagation();
                event.stopImmediatePropagation();
                let video = this.$refs['video'];
                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
            },
            toggleMute: function () {
                let video = this.$refs['video'];
                if (video.muted) {
                    video.muted = false;
                    video.volume = 0.5;
                } else {
                    video.muted = true;
                    video.volume = 0;
                }
            },
            setVolume: function (event) {
                let video = this.$refs['video'];
                video.volume = event.srcElement.value;
                video.muted = event.srcElement.value === 0;
            },
            setVolumeVars: function () {
                let video = this.$refs['video'];
                this.volume = video.volume;
                this.isMuted = video.volume === 0 || video.muted;
            },
            handlePause: function (event) {
                let video = this.$refs['video'];
                this.isPlaying = !video.paused;
            },

            handlePlaying: function (event) {
                let video = this.$refs['video'];
                this.isPlaying = !video.paused;
            },


            getBlankCell: function () {
                return {isBlankCell:true, isReady:false, id: this.getRandId()}
            },
            getRandId: function () {
              return 'Rand' + this.$janus.randomString(12)
            },
            addParticipantComponent: function (id, displayname, stream, hasVideo) {

                this.removeParticipantComponent(id);

                let index = null;
                for(let i = 0, len = this.participants.length; i < len; i++) {
                    if(this.participants[i].isBlankCell) {
                        index = i;
                        break;
                    }
                }

                if(index !== null) {
                    this.participants.splice(index, 1, {isBlankCell: false, isReady:true, id, displayname, stream, hasVideo});
                }
                else {
                    console.log('Maximum limit reached');
                }
            },
            removeParticipantComponent:function (id) {
                for(let i = 0, len = this.participants.length; i < len; i++ ) {
                    if(this.participants[i].id === id) {
                        this.participants.splice(i, 1, this.getBlankCell());
                        break;
                    }
                }
            }
        },
        videoroom: {

            // Leaving all events here for reference
            
            addParticipant : function (id, displayname, stream, hasVideo) {
                this.addParticipantComponent(id, displayname, stream, hasVideo);
            },
            removeParticipant : function (id) {
                this.removeParticipantComponent(id);
            },
            streamBitrate: function (id, bitrate) {
                console.log(`id:${id}, bitrate:${bitrate}`);
            },
            error: function (error) {

            },
            consentDialog: function (isOn) {
                console.log(`CONSENT ${isOn}`);
            },
            isLocalParticipantReady: function (isReady) {
                
            },
            addLocalParticipant: function (stream, hasVideo) {

            },
            addMainStream: function (id, displayname, stream, hasVideo) {
                let video = this.$refs['video'];
                if(stream) {
                    this._hasMainStream = true;
                    this.$janus.attachMediaStream(video, stream)
                }
            },
            removeLocalParticipant: function () {
                
            },
            destroy: function () {
                
            }

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/DemoRoom.vue